import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceEmbeddedWidgetsRoute: InvariantJiraRoute = {
	name: 'csm-experience-embedded-widgets',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed',
	exact: true,
};
